module.exports = __webpack_public_path__ + "img/gzdz.2f831fb2.png";